import { useEffect, useState } from 'react';
import Switch from '@material-ui/core/Switch';
import { Grid, Box, Dialog, Divider, withStyles, Button, Theme, createStyles } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';

import { useSelector } from "react-redux";

const styles = (theme: Theme) =>
	createStyles({
		root: {
			margin: 0,
			padding: theme.spacing(2),
			paddingTop: 26
		},
		closeButton: {
			position: 'absolute',
			right: theme.spacing(1),
			background: 'transparent!important'
		},
		header: {
			color: '#212D40',
			fontFamily: 'Spartan-bold',
			fontSize: 24,
			paddingLeft: 17,
			paddingBottom: 7,
			display: 'flex',
			alignItems: 'center'
		}
	});

const ViewRole = ({ open, onClose }: any) => {

	const { roleDetails } = useSelector((state: any) => state.adminRole);
	const [state, setState] = useState({
		roleName: "",
		roleAlias: "",
		roleDesc: "",
		active: ""
	});
	const [accessPages, setAccessPages] = useState({
		home_page: false,
		my_profile: true,
		admin_roles: false,
		admin_users: false,
		test_page: false,
		participant_dashboard: false,
		participant_async: false,
		participant_mod: false,
		creator_dashboard: false,
		creator_onboarding: false,
		experience_builder: false,
		experience_manager: false,
		experience_live: false,
		experience_analysis: false,
		trial_onboarding:false,
		trial_dashboard:false,
		trial_builder:false,
		trial_experiences:false,
		trial_profile:false,
		trial_admin:false
	})

	//set all data when open edit role popup
	useEffect(() => {
		if (roleDetails !== undefined && roleDetails.accesspages !== undefined) {
			setState({
				roleName: roleDetails.role_name,
				roleAlias: roleDetails.role_alias,
				roleDesc: roleDetails.role_desc,
				active: roleDetails.active
			});
			setAccessPages(
				roleDetails.accesspages
			)
		}
	}, [roleDetails]);


	const DialogTitle = withStyles(styles)((props: any) => {
		const { children, classes, onClose, ...other } = props;
		return (
			<MuiDialogTitle disableTypography className={classes.root} {...other}>
				<div className={classes.header}>
					{children}
					{onClose ? (
						<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
							<img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
						</IconButton>
					) : null}
				</div>
			</MuiDialogTitle>
		);
	});

	return (
		<div className="card">
			<Grid container>
				<Grid item>
					<Dialog
						
						disableEscapeKeyDown
						fullWidth={true}
						maxWidth={'sm'}
						open={open}
						className="modal-custom"
						scroll="body"
					>
						<div>
							<DialogTitle onClose={onClose}>
								Role details
        			</DialogTitle>
							<Divider />

							<Box m={4} pl={1} mt={0} pr={1}>
								<div className="roleview-container">
									<div className="main-box">
										<div className="main-box-header">
											<p>Role Name::</p>
										</div>
										<div>
											<p>{state.roleName ? state.roleName : "-"}</p>
										</div>
									</div>
									<div className="main-box">
										<div className="main-box-header">
											<p>Role Alias::</p>
										</div>
										<div>
											<p>{state.roleAlias ? state.roleAlias : "-"}</p>
										</div>
									</div>
									<div className="main-box">
										<div className="main-box-header">
											<p>Role Description::</p>
										</div>
										<div>
											<p>{state.roleDesc ? state.roleDesc : "-"}</p>
										</div>
									</div>
									<div className="main-box">
										<div className="main-box-header">
											<p>Role Status::</p>
										</div>
										<div>
											<p>{state.active ? "Active" : "Inactive"}</p>
										</div>
									</div>
								</div>

								<Grid container spacing={3} className="role-create">
									<Grid item xs={6}>
										<Grid container spacing={1}>
											<Grid item xs={12}>
												<label>Home</label>
												<Switch
													checked={accessPages.home_page ? accessPages.home_page : false}
													className="access-page-switch"
													color="primary"
													name="home_page"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Admin Roles</label>
												<Switch
													checked={accessPages.admin_roles ? accessPages.admin_roles : false}
													className="access-page-switch"
													color="primary"
													name="admin_roles"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Participant dashboard</label>
												<Switch
													checked={accessPages.participant_dashboard ? accessPages.participant_dashboard : false}
													className="access-page-switch"
													color="primary"
													name="participant_dashboard"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Participant mod</label>
												<Switch
													checked={accessPages.participant_mod ? accessPages.participant_mod : false}
													className="access-page-switch"
													color="primary"
													name="participant_mod"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Create onboarding</label>
												<Switch
													checked={accessPages.creator_onboarding ? accessPages.creator_onboarding : false}
													className="access-page-switch"
													color="primary"
													name="creator_onboarding"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Experience manager</label>
												<Switch
													checked={accessPages.experience_manager ? accessPages.experience_manager : false}
													className="access-page-switch"
													color="primary"
													name="experience_manager"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Experience analysis</label>
												<Switch
													checked={accessPages.experience_analysis ? accessPages.experience_analysis : false}
													className="access-page-switch"
													color="primary"
													name="experience_analysis"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial dashboard</label>
												<Switch
													checked={accessPages.trial_dashboard ? accessPages.trial_dashboard : false}
													className="access-page-switch"
													color="primary"
													name="trial_dashboard"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial experiences</label>
												<Switch
													checked={accessPages.trial_experiences ? accessPages.trial_experiences : false}
													className="access-page-switch"
													color="primary"
													name="trial_experiences"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial admin</label>
												<Switch
													checked={accessPages.trial_admin ? accessPages.trial_admin : false}
													className="access-page-switch"
													color="primary"
													name="trial_admin"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
										</Grid>
									</Grid>
									<Grid item xs={6}>
										<Grid container spacing={1}>
											<Grid item xs={12}>
												<label>User profile</label>
												<Switch
													disabled={true}
													checked={accessPages.my_profile ? accessPages.my_profile : false}
													className="access-page-switch"
													color="primary"
													name="my_profile"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Admin Users</label>
												<Switch
													checked={accessPages.admin_users ? accessPages.admin_users : false}
													className="access-page-switch"
													color="primary"
													name="admin_users"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Participant async</label>
												<Switch
													checked={accessPages.participant_async ? accessPages.participant_async : false}
													className="access-page-switch"
													color="primary"
													name="participant_async"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Creator dashboard</label>
												<Switch
													checked={accessPages.creator_dashboard ? accessPages.creator_dashboard : false}
													className="access-page-switch"
													color="primary"
													name="creator_dashboard"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Experience builder</label>
												<Switch
													checked={accessPages.experience_builder ? accessPages.experience_builder : false}
													className="access-page-switch"
													color="primary"
													name="experience_builder"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Experience live</label>
												<Switch
													checked={accessPages.experience_live ? accessPages.experience_live : false}
													className="access-page-switch"
													color="primary"
													name="experience_live"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial onboarding</label>
												<Switch
													checked={accessPages.trial_onboarding ? accessPages.trial_onboarding : false}
													className="access-page-switch"
													color="primary"
													name="trial_onboarding"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial builder</label>
												<Switch
													checked={accessPages.trial_builder ? accessPages.trial_builder : false}
													className="access-page-switch"
													color="primary"
													name="trial_builder"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
											<Grid item xs={12}>
												<label>Trial profile</label>
												<Switch
													checked={accessPages.trial_profile ? accessPages.trial_profile : false}
													className="access-page-switch"
													color="primary"
													name="trial_profile"
													inputProps={{ 'aria-label': 'primary checkbox' }}
												/>
											</Grid>
										</Grid>
									</Grid>
								</Grid>

							</Box>
							<Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
								<Button onClick={onClose}>
									Cancel
								</Button>&nbsp;&nbsp;&nbsp;
							</Box>
						</div>
					</Dialog>
				</Grid>
			</Grid>
		</div>
	)
};

export default ViewRole;

